//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '../../themes/dark/ui/Betslip/Button.vue'
export default {
  components: { Button },
  props: ['event', 'statsURL'],
  computed: {
    stats() {
      return _.get(this.event, 'stats')
    }
  },
  mounted() {},
  methods: {
            openStats() {
      this.$store.commit('setStatId', this.event.id)
      this.$modal.show('modal-stats')
    },
  }
}
